import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeSpecialChars' })
export class RemoveSpecialCharsPipe implements PipeTransform {
  transform(value: string): any {
    if (value == null || value === undefined) {
      return '';
    }
    return value.replace(/[^\w\s]/gi, '').replace(/\s+/g, '-');
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/removeSpecialChar.pipe.ts